export const commandPaletteDarkTheme = {
  modal: "command-palette-modal",
  overlay: "command-palette-overlay",
  container: "command-palette-container",
  content: "command-palette-content",
  containerOpen: "command-palette-containerOpen",
  input: "command-palette-input",
  inputOpen: "command-palette-inputOpen",
  inputFocused: "command-palette-inputFocused",
  spinner: "command-palette-spinner",
  suggestionsContainer: "command-palette-suggestionsContainer",
  suggestionsContainerOpen: "command-palette-suggestionsContainerOpen",
  suggestionsList: "command-palette-suggestionsList",
  suggestion: "command-palette-suggestion",
  suggestionFirst: "command-palette-suggestionFirst",
  suggestionHighlighted: "command-palette-suggestionHighlighted",
  trigger: "command-palette-trigger",
};

export const commandPaletteLightTheme = {
  modal: "command-palette-modal light-theme",
  overlay: "command-palette-overlay light-theme",
  container: "command-palette-container light-theme",
  content: "command-palette-content light-theme",
  containerOpen: "command-palette-containerOpen light-theme",
  input: "command-palette-input light-theme",
  inputOpen: "command-palette-inputOpen light-theme",
  inputFocused: "command-palette-inputFocused light-theme",
  spinner: "command-palette-spinner light-theme",
  suggestionsContainer: "command-palette-suggestionsContainer light-theme",
  suggestionsContainerOpen: "command-palette-suggestionsContainerOpen light-theme",
  suggestionsList: "command-palette-suggestionsList light-theme",
  suggestion: "command-palette-suggestion light-theme",
  suggestionFirst: "command-palette-suggestionFirst light-theme",
  suggestionHighlighted: "command-palette-suggestionHighlighted light-theme",
  trigger: "command-palette-trigger light-theme",
};
